module.exports = __webpack_public_path__ + "static/media/discover.dfd44074.svg";